
export default {
    
    namespaced: true,

    state: {
        fundsRecentlyViewed: [],
        fundsRecentlyCompared: [],
        fundsRecentlyReferrals: []
        
    },
    getters: {

    },
    actions: {
       
    },
    mutations: {
        SET_FUNDS_RECENTLY_VIEWED(state, value) {
            state.fundsRecentlyViewed = value;
        },
        SET_FUNDS_RECENTLY_COMPARED(state, value) {
            state.fundsRecentlyCompared = value;
        },
        SET_FUNDS_RECENTLY_REFERRAL(state, value) {
            state.fundsRecentlyReferrals = value;
        }
    }
}


